import { render, staticRenderFns } from "./ReagentReplacementList.vue?vue&type=template&id=336f5178&scoped=true&"
import script from "./ReagentReplacementList.vue?vue&type=script&lang=js&"
export * from "./ReagentReplacementList.vue?vue&type=script&lang=js&"
import style0 from "./ReagentReplacementList.vue?vue&type=style&index=0&id=336f5178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f5178",
  null
  
)

export default component.exports